
import React from "react";
import moment from "moment";
import { CONSTANTS } from "../shared/constants";
import { useNavigate } from "react-router-dom";
import { Favourite, Info, NotFavourite } from "../icons";

const PurchaseTable = ({ style, rowColor, isMobile }) => {
    const cars = [
        {
            NO: 1,
            imgPath: 'car1.png',
            name: 'Car A',
            year: 2020,
            km: 15000,
            cc: 2000,
            engine: 'V6',
            price: 25000,
            location: 'City X',
            engineNumber: 'ENG123456',
            path: 'Live Auction',
            datas: 'Some additional datas about Car A',
            dataofpurchase: '02/08/23',
            duedate: '08/08/23',
            color: 'DAMAGE',
            balance: 75000,
            fuel: 'GASOLINE',

        },
        {
            NO: 2,
            imgPath: 'car2.png',
            name: 'Car B',
            year: 2013,
            km: 250000,
            cc: 1400,
            engine: 'Inline-rrr',
            price: 18000,
            location: 'City H',
            engineNumber: 'ENG789012dtd',
            path: 'Live Auction',
            datas: 'Some additional datas about Car B',
            dataofpurchase: '02/08/23',
            duedate: '08/08/23',
            color: 'DAMAGE',
            balance: 0,
            fuel: 'GASOLINE',

        },
        {
            NO: 3,
            imgPath: 'car3.png',
            name: 'Car C',
            year: 2025,
            km: 152000,
            cc: 1000,
            engine: 'V6',
            price: 215000,
            location: 'City V',
            engineNumber: 'ENG123456shia',
            path: 'Live Auction',
            datas: 'Some additional datas about Car C',
            dataofpurchase: '02/08/23',
            duedate: '08/08/23',
            color: 'DAMAGE',
            balance: 75000,
            fuel: 'HYBRID',
        },
        {
            NO: 4,
            imgPath: 'car1.png',
            name: 'Car D',
            year: 2014,
            km: 220000,
            cc: 1500,
            engine: 'Inline-5',
            price: 148000,
            location: 'City r\R',
            engineNumber: 'ENG78901233',
            path: 'Live Auction',
            datas: 'Some additional datas about Car D',
            dataofpurchase: '02/08/23',
            duedate: '08/08/23',
            color: 'DAMAGE',
            balance: 0,
            fuel: 'GASOLINE',
        },
        {
            NO: 5,
            imgPath: 'car.png',
            name: 'Car E',
            year: 2019,
            km: 10000,
            cc: 1300,
            engine: 'Inline-8',
            price: 118000,
            location: 'City W',
            engineNumber: 'ENG78901212w',
            path: 'Live Auction',
            datas: 'Some additional datas about Car E',
            dataofpurchase: '02/08/23',
            duedate: '08/08/23',
            color: 'DAMAGE',
            balance: 75000,
            fuel: 'HYBRID',
        },
        // Add more cars here...
    ];
    const navigate = useNavigate();
    const getDate = (date) => {
        if (date) {
            const japanDateTime = moment(date).format("YYYY-MM-DD");

            return japanDateTime;
        }

        return "";
    };
    const handleClick = (_id) => {
        navigate(`/car-details/${_id}`);
    };

    return (
        <>
            {isMobile === false && (
                <div className="auction-table-purchase" style={style}>
                    <div className="thead">
                        <div className="table-no">NO.</div>
                        <div>Photo</div>
                        <div>Goods Details</div>
                        <div>Date</div>
                        <div>Invoice Amount</div>
                        <div>Payment After Due Date</div>
                        <div>Received Amount</div>
                        <div>Remarks</div>
                    </div>
                    {cars &&
                        cars.map((car, index) => (
                            <div
                                key={index}
                                className={`table-row ${index % 2 === 0 ? "even-row" : "odd-row"
                                    }`}

                            >
                                {rowColor && <span className="row-color"><p className="purchase-no">{car.NO}</p></span>}
                                <div className="no-border">
                                    <img
                                        src={car.imgPath} alt={car.name}
                                        onClick={() => handleClick(car?._id)}
                                        style={{ cursor: "pointer" }}
                                    />
                                </div>
                                <div>
                                    <b
                                        onClick={() => handleClick(car?._id)}
                                        style={{ cursor: "pointer" }}
                                    >
                                        NO. {car?.engineNumber}
                                    </b>
                                    <p className="bold-and-black">
                                        <b
                                            onClick={() => handleClick(car?._id)}
                                            style={{ cursor: "pointer" }}
                                        >
                                            {car.name}
                                        </b>
                                    </p>
                                    <p >
                                        <b
                                            onClick={() => handleClick(car?._id)}
                                            style={{ cursor: "pointer" }}
                                        >
                                            {car.year}
                                        </b>
                                    </p>
                                    <p className="bold-and-black">
                                        <b
                                            onClick={() => handleClick(car?._id)}
                                            style={{ cursor: "pointer" }}
                                        >
                                            {car?.path}
                                        </b>
                                    </p>
                                    {car?.otherDetails?.map((detail, i) => (
                                        <p key={i}>{detail}</p>
                                    ))}
                                </div>
                                <div className="details">
                                    <b
                                        onClick={() => handleClick(car?._id)}
                                        style={{ cursor: "pointer" }}
                                    >
                                        <p className="bold-and-black">  Data of Purchase</p> {car?.dataofpurchase}
                                    </b>
                                    <b
                                        onClick={() => handleClick(car?._id)}
                                        style={{ cursor: "pointer" }}
                                    >
                                        <p className="bold-and-black">Due Data</p> {car?.duedate}
                                    </b>
                                    {/* <p>
                                        <span className="bold-and-black">Engine:</span>{" "}
                                        {car?.engine}
                                    </p> */}
                                    {car?.condition === "DAMAGE" && (
                                        <button className="damaged"> Damage</button>
                                    )}
                                    {car?.condition === "USED" && (
                                        <button className="used"> Used</button>
                                    )}
                                </div>
                                <div>
                                    <p className="bold-and-black">
                                        <b>{car?.price.toLocaleString()} Yen</b>
                                    </p>
                                </div>
                                <div>

                                </div>
                                <div>
                                    <p >
                                        <b>{car.dataofpurchase}</b>&nbsp;&nbsp;<b className="bold-and-black">{car?.price.toLocaleString()} Yen</b><br />
                                        <b>{car.dataofpurchase}</b>&nbsp;&nbsp;<b className="bold-and-black">{car?.price.toLocaleString()} Yen</b>
                                    </p>
                                </div>
                                <div>
                                    {car?.color === "DAMAGE" && (
                                        <button className="damaged-purchase"><b> Balance <br /> {car?.balance.toLocaleString()} Yen</b></button>
                                    )}
                                </div>
                            </div>
                        ))}
                </div>
            )}

            {isMobile &&
                cars.map((card, i) => {
                    return (
                        <div key={i} className="mainCardslistSearch-Purchase">
                            <div className="containerSearchPurchase">
                                <div className="searchimagecontainer-Purchase">
                                    <img
                                        className="search-Imglist-Purchase"
                                        src={card.imgPath} alt={card.name}
                                    />
                                </div>
                                <div className="cardscontentcontainer-Purchase">
                                    <div className="contentSearch-Purchase">
                                        <a style={{ marginTop: 7, fontSize: 11, fontWeight: 800, marginLeft: -2, marginBottom: 1 }}
                                            href="#auctionno">
                                            No.{card?.engineNumber}
                                        </a>

                                        <div className="damagedUsedContainer-Purchase">
                                            {card?.condition === "DAMAGE" && (
                                                <button className="damagedcard-Purchase">
                                                    <span className="some_thing">Damaged</span>
                                                </button>
                                            )}
                                            {card?.condition === "USED" && (
                                                <button className="usedcard-Purchase">
                                                    <span className="some_thing">Used</span>
                                                </button>
                                            )}
                                            <div className="iconContainer-Purchase">
                                                {card?.isFavorite === true ? (
                                                    <Favourite style={{ width: 17, height: 17 }} />
                                                ) : (
                                                    <NotFavourite style={{ width: 17, height: 17 }} />
                                                )}
                                            </div>
                                        </div>
                                    </div>
                                    <div style={{ marginTop: -7, marginLeft: -2, marginBottom: 1 }}>
                                        <span
                                            onClick={() => handleClick(card?._id)}
                                            className="cardNameSearch-Purchase"
                                        >
                                            {card?.name}
                                        </span>
                                    </div>
                                    <div style={{ marginTop: -5, marginLeft: -1, marginBottom: 1 }}>
                                        <span style={{ color: "#dc0000", fontWeight: "bold", fontSize: 12 }}>
                                            <b>{card?.price.toLocaleString()} Yen</b>
                                        </span>
                                    </div>
                                    <div style={{ display: "flex" }}>
                                        <span style={{ fontSize: 10 }}>
                                            {card?.auctionType ===
                                                CONSTANTS.AUCTION_TYPES.NEGOTIATION
                                                ? "NEGOTIATION"
                                                : card?.auctionType}
                                        </span>
                                        <span className="auctionendDate-Purchase">
                                            {getDate(card?.duedate)}
                                        </span>
                                    </div>
                                    <div style={{ display: "flex", marginTop: 2 }}>
                                        <b style={{ fontSize: 10 }}>Location : </b>
                                        <span className="currentAddressSearch-Purchase">
                                            {" "}
                                            {card?.location}{" "}
                                        </span>
                                        <span className="infoQuestion">?</span>
                                        {/* <Info className="infoIcon-Purchase" /> */}
                                    </div>
                                    <div>
                                        <p className="detailsofVehicle-Purchase ">
                                            <span>{card?.year} &nbsp; </span>| &nbsp;&nbsp;{" "}
                                            <span>{card?.km.toLocaleString()} km &nbsp;</span>{" "}
                                            | &nbsp;&nbsp;
                                            <span>
                                                {card?.cc.toLocaleString()} cc &nbsp;
                                            </span>{" "}
                                            | &nbsp;&nbsp;
                                            <span>{card?.fuel}</span>
                                        </p>
                                    </div>

                                </div>
                            </div>
                        </div >
                    );
                })}
        </>
    );
};

export default PurchaseTable;